import React, {Fragment, useEffect, useMemo, useRef, useState} from 'react'
import {CustomContainer, CustomHeader, RequiredItemsBadge} from "@pages/new-design-components/custom-components";
import CustomSearch from "@pages/components/CustomSearch";
import {Col} from "reactstrap";
import axios from "axios";
import {LoaderContainer, override} from "@pages/reusable-components/styled-components";
import DebtManagementTable from "@pages/components/DebtManagement/DebtManagementTable";
import {ClipLoader} from "react-spinners";
import SendQuoteEmail from "@pages/components/DebtManagement/SendQuoteEmail";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {GET_EMAIL_TEMPLATES_REQUEST} from "@redux/Email/actions";
import usePrevious from "@hooks/useprevious";
import {API_URL} from "@constants/index";
import {Doughnut, Line} from "react-chartjs-2";
import {GET_CUSTOMERS_DEBT_REQUEST, GET_DEBT_STATS_REQUEST} from "@redux/Customer/actions";
import Picker from "@pages/components/DatePicker";
import notify from '@utils/notify';
import OwedByInvoiceType from "@pages/components/DebtManagement/OwedByInvoiceType";


export default function ReportingAnalytics() {

    const [showSendEmail, setShowSendEmail] = useState(false)
    const [showRangeFilters, setShowRangeFilters] = useState(false)
    const dispatch = useDispatch();
    const [loading,setLoading] = useState(true);
    const [tableLoading,setTableLoading] = useState(true);
    const [tableData,setTableData] = useState([]);
    const [activeData,setActiveData] = useState(null);
    const [activeTab, setActiveTab] = useState('today');
    const [overviewFilter,setOverviewFilter] = useState({from: '',to:''});
    const [filter,setFilter] = useState({
        page: 1
    });
    const {templates} = useSelector(
        (state) => state.emailTemplateState,
        shallowEqual
    );
    const {
        customersDebts,
        getCustomersDebtError,
        getCustomersDebtSuccess,
        getDebtStatsSuccess,
        getDebtStatsError,
        debtStats,
    } = useSelector((state) => state.customer, shallowEqual);
    const getDebtStatsSuccessPrev = usePrevious(getDebtStatsSuccess);
    const getDebtStatsErrorPrev = usePrevious(getDebtStatsError);
    const getCustomersDebtSuccessPrev = usePrevious(getCustomersDebtSuccess);
    const getCustomersDebtErrorPrev = usePrevious(getCustomersDebtError);
    const tabs = [
        {
            key: 'today',
            label: 'Day',
        },
        {
            key: 'month',
            label: 'Month',
        },
        {
            key: 'year',
            label: 'Year',
        },
        {
            key: 'custom',
            label: 'Range',
            addFilter: true
        },


    ]
    const keys = [
        {
            key: 'customer_name_deep',
            label: 'Customer'
        } ,
        {
            key: 'amount_due',
            label: 'Amount'
        } ,
        {
            key: 'due_date',
            label: 'Due Date'
        },

        {
            key: 'overdue_duration_nested',
            label: 'Overdue duration'
        },

        {
            key: 'options',
        },
    ]
    const fetchData = (localFilter = {}) => {
        dispatch({
            type: GET_CUSTOMERS_DEBT_REQUEST,
            payload: {...localFilter}
        });
    }

    useEffect(()=>{
        fetchData(filter)
        dispatch({
            type: GET_EMAIL_TEMPLATES_REQUEST,
            data: {
                forSelection: true,
                mail_type: 'Deal'
            }
        });

    },[])

    useEffect(()=>{
        if (getCustomersDebtSuccess && getCustomersDebtSuccessPrev === false) {
            setTableData(customersDebts?.data)
            setTableLoading(false)
            if (loading) {
                getOverviewData({range: activeTab})
            }
        }
    },[getCustomersDebtSuccess,getCustomersDebtSuccessPrev])
    useEffect(()=>{
        if (getCustomersDebtError && getCustomersDebtErrorPrev === false) {
            setLoading(false)
            setTableLoading(false)
            notify.warning('Something went wrong please try again later!');
        }
    },[getCustomersDebtError,getCustomersDebtErrorPrev])

    useEffect(()=>{
            if (getDebtStatsSuccess && getDebtStatsSuccessPrev === false) {
                setLoading(false)
            }
        },
        [getDebtStatsSuccessPrev,getDebtStatsSuccess])
    useEffect(()=>{
        if (getDebtStatsError && getDebtStatsErrorPrev === false) {
            setLoading(false)
            notify.warning('Something went wrong while getting stats!');
        }
    },[getDebtStatsError,getDebtStatsErrorPrev])
    const getOverviewData = (localFilter = {}) => {
        dispatch({
            type: GET_DEBT_STATS_REQUEST,
            payload: {...localFilter}
        });
    }

    const filterData = ({key,value}) => {
        let tempFilter = {...filter}
        tempFilter[key] = value
        setFilter(tempFilter)
        setTableLoading(true)
        fetchData(tempFilter)
    }
    const filterOverviewStats = ({key,value}) => {
        let overviewTemp = {...overviewFilter}
        overviewTemp[key] = value
        setOverviewFilter(overviewTemp)
        getOverviewData(overviewTemp)
    }

    const viewDetails = (index) => {
        const data = tableData[index];
        setActiveData(data)
        setShowSendEmail(true)
    }
    const deleteDetail = (index) => {
        console.log('deleteDetail',index)
    }

    const sendEmail = ({data}) => {
        let formData = new FormData();
        formData.append('message',data?.message);
        formData.append('subject',data?.subject);
        formData.append('to[]',data.email);
        if (data.hasOwnProperty('documents') && data.documents.length) {
            for (const document of data?.documents) {
                if (document.file) {
                    formData.append('fileLists[]', document.file);
                }
            }
        }

        formData.append('resource_id',activeData.id);
        formData.append('resource_type','Customer');
        axios({
            method: 'POST',
            url: API_URL + '/processor-emails',
            headers: {
                'content-type': 'multipart/form-data',
            },
            data: formData
        }).then(res=>{
            console.log('res:',res)
        }).catch(err=>{
            console.log('err:',err)
        })

    }
    const dealsStats = useMemo(() => {
        if (!debtStats?.current) return null;

        const localStats = {
            total_collected: parseFloat(debtStats.current.total_collected).toFixed(2),
            total_debt: parseFloat(debtStats.current.total_debt).toFixed(2),
            total_overdue: parseFloat(debtStats.current.total_overdue).toFixed(2),
        };

        const chartData = {
            labels: ['Total Collected', 'Total Debt', 'Total Overdue'],
            datasets: [
                {
                    label: 'Debt Stats',
                    data: [
                        localStats.total_collected,
                        localStats.total_debt,
                        localStats.total_overdue
                    ],
                    backgroundColor: ['#48c029', '#ed7d31', '#f85151'],
                    borderColor: ['#48c029', '#ed7d31', '#f85151'],
                    borderWidth: 1,
                },
            ],
        };

        const chartOptions = {
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function (tooltipItem) {
                            return `${tooltipItem.label}: ${tooltipItem.raw}`;
                        }
                    }
                },
                legend: {
                    labels: {
                        usePointStyle: true,
                        font: {
                            size: 14,
                        },
                    },
                },
            },
            responsive: true,
        };

        return <Doughnut height={1} width={1} data={chartData} options={chartOptions} />;
    }, [debtStats]);
    const dealsStatsAera = useMemo(() => {
        if (!debtStats?.current) return null;

        const stats = debtStats.current;

        const chartData = {
            labels: ['Total Collected', 'Total Debt', 'Total Overdue'],
            datasets: [
                {
                    label: 'Payments Stats',
                    data: [
                        parseFloat(stats.total_collected),
                        parseFloat(stats.total_debt),
                        parseFloat(stats.total_overdue),
                    ],
                    backgroundColor: '#AACAFFFF',
                    borderColor: '#3080EB',
                    borderWidth: 2,
                    fill: true,
                    tension: 0.4,
                },
            ],
        };

        const chartOptions = {
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        font: {
                            size: 14,
                        },
                    },
                },
                tooltip: {
                    callbacks: {
                        label: function (tooltipItem) {
                            return `${tooltipItem.label}: ${tooltipItem.raw.toLocaleString()}`;
                        },
                    },
                },
            },
            responsive: true,
            scales: {
                x: {
                    beginAtZero: true,
                },
                y: {
                    beginAtZero: true,
                },
            },
        };

        return <Line height={1} width={1} data={chartData} options={chartOptions} />;
    }, [debtStats]);

    return (
        loading ?
            <LoaderContainer>
                <ClipLoader
                    css={override}
                    size={40}
                    color={`#7B61E4`}
                    loading={loading}
                />
            </LoaderContainer> :
            <div className={'container-fluid debt-background pt-3'}>
                <CustomContainer backgroundColor={'#FFF'} borderRadius="16px" padding="16px" className={'mb-2'}>
                    <CustomHeader fontSize={'20px'} weight={'600'} lineHeight={'unset'} >Analytics</CustomHeader>
                    <div className={'d-flex g-5 mb-3 flex-wrap'}>
                             {
                                 tabs.map((tab,index) => {
                                     return (
                                         <Fragment key={'idx_'+index}>
                                             <RequiredItemsBadge backgroundColor={'#F2F2F2'} type={tab.key} onClick={()=> {
                                                 setActiveTab(tab.key);
                                                 if (!tab?.addFilter) {
                                                     if (showRangeFilters) {
                                                         setShowRangeFilters(false)
                                                     }
                                                     getOverviewData({range: tab.key})
                                                 } else {
                                                     setShowRangeFilters(true)
                                                 }
                                             }
                                             } active={activeTab === tab.key}>
                                                 {tab.label}
                                             </RequiredItemsBadge>
                                         </Fragment>
                                     )
                                 })
                             }
                             {showRangeFilters && <>
                                 <Picker
                                     value={overviewFilter?.from}
                                     placeholderText={'From'}
                                     onChange={(date) => {
                                         filterOverviewStats({key: 'from', value: date})
                                     }}
                                 />
                                 <Picker
                                     value={overviewFilter?.to}
                                     placeholderText={'To'}
                                     onChange={(date) => {
                                         filterOverviewStats({key: 'to', value: date})
                                     }}
                                 />
                             </>}
                         </div>
                    <div className={'d-flex  flex-wrap'}>
                        <div className={'container-350 text-center'}>
                            {dealsStatsAera}
                        </div>
                        <div className={'container-350 text-center'}>
                            {dealsStats}
                        </div>

                    </div>

                </CustomContainer>
                <OwedByInvoiceType/>
                {
                    showSendEmail ?
                        <SendQuoteEmail sendEmail={sendEmail} templates={templates} data={activeData} setShowSendQuoteEmail={()=>{setShowSendEmail(false)}}/> :
                        <>
                            <CustomHeader fontSize={'20px'} weight={'600'} lineHeight={'unset'} >Debt List</CustomHeader>
                            <Col lg={4} sm={12} md={5}>
                                <CustomSearch
                                    onChange={(e) => {
                                        filterData({key:'full_name',value: e.target.value})
                                    }}
                                    placeholder="Customer Name"
                                />
                            </Col>
                            <div className={'table-container'}>
                                <DebtManagementTable keys={keys} loading={tableLoading} tableData={tableData} viewDetails={viewDetails} deleteDetail={deleteDetail} optionValues={[
                                    {
                                        label: 'Send to Debt Recovery',
                                        action: viewDetails
                                    },
                                    {
                                        label: 'Resend Statement',
                                        action: deleteDetail
                                    }
                                ]}/>
                            </div>
                        </>
                }

            </div>
    )
}